import { mapFields } from 'vuex-map-fields'
import { v4 as uuidv4 } from 'uuid'

import dedent from 'dedent'
import hljs from 'highlight.js'
import debounce from 'lodash/debounce'
import { quillEditor } from 'vue-quill-editor'
import 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'

// highlight.js style
import 'highlight.js/styles/tomorrow.css'

// import theme style
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

// import JSON editor
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  components: {
    quillEditor,
    VJsoneditor
  },
  computed: {
    ...mapFields('dialogEdit', ['typeDialog']),
    mdMenuContent () {
    }
  },
  data () {
    return {
      options: {
        mode: 'code'
      },
      variableAdd: {
        name: '',
        value: ''
      },
      editorOption: {
        modules: {
          'emoji-toolbar': true,
          'emoji-shortname': true,
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['emoji', 'link'],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean']
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value
          }
        }
      }
    }
  },
  methods: {
    onEditorChange: debounce(function (
      value,
      genericIndex,
      valuesIndex,
      outputResponseIndex
    ) {
      if (
        this.nodeData.data?.metadata?._customization?.mcr !== true &&
        outputResponseIndex === 'not-customizable'
      ) {
        // console.log(valuesIndex)
        const generic = this.nodeData.data.output.generic[genericIndex]
        generic.values[valuesIndex].text = value.html
      } else {
        // console.log(valuesIndex)
        const response = this.nodeData.data.outputResponses[outputResponseIndex]
        response.output.generic[genericIndex].values[valuesIndex].text =
          value.html
      }
    },
    466),
    createHtml (text) {
      return dedent`${text}`
    },
    sample () {
      // console.log('opa')
    },
    addVariable () {
      if (this.variableAdd.name !== '') {
        const nodeData = this.nodeData.data
        nodeData.context[this.variableAdd.name] = this.variableAdd.value
        this.variableAdd.name = ''
        this.variableAdd.value = ''
      }
    },
    removeVariable (name, outputResponsesIndex) {
      // console.log(name)
      const nodeData = this.nodeData.data
      if (
        nodeData?.metadata?._customization?.mcr !== true &&
        outputResponsesIndex === 'not-customizable'
      ) {
        delete nodeData.context[name]
        this.variableAdd.name = ' '
        this.variableAdd.name = ''
        // console.log(nodeData.context)
      } else {
        const response = nodeData.outputResponses[outputResponsesIndex]
        delete response.context[name]
        this.variableAdd.name = ' '
        this.variableAdd.name = ''
      }
    },
    moveUp (genericIndex, outputResponseIndex) {
      const nodeData = this.nodeData.data
      if (
        nodeData?.metadata?._customization?.mcr !== true &&
        outputResponseIndex === 'not-customizable'
      ) {
        if (!this.isFirst(genericIndex, 'not-customizable')) {
          const wasDown = nodeData.output.generic[genericIndex]
          const wasUp = nodeData.output.generic[genericIndex - 1]
          nodeData.output.generic.splice(genericIndex, 1, wasUp)
          nodeData.output.generic.splice(genericIndex - 1, 1, wasDown)
        }
      } else {
        if (!this.isFirst(genericIndex, outputResponseIndex)) {
          const response = nodeData.outputResponses[outputResponseIndex]
          const wasDown = response.output.generic[genericIndex]
          const wasUp = response.output.generic[genericIndex - 1]
          response.output.generic.splice(genericIndex, 1, wasUp)
          response.output.generic.splice(genericIndex - 1, 1, wasDown)
        }
      }
    },
    isFirst (genericIndex, outputResponsesIndex) {
      if (
        this.nodeData.data?.metadata?._customization?.mcr !== true &&
        outputResponsesIndex === 'not-customizable'
      ) {
        if (this.nodeData.data.output.generic[genericIndex - 1]) {
          return false
        } else {
          return true
        }
      } else {
        if (
          this.nodeData.data?.outputResponses[outputResponsesIndex]?.output
            ?.generic[genericIndex - 1]
        ) {
          return false
        } else {
          return true
        }
      }
    },
    moveDown (genericIndex, outputResponseIndex) {
      const nodeData = this.nodeData.data
      if (
        nodeData?.metadata?._customization?.mcr !== true &&
        outputResponseIndex === 'not-customizable'
      ) {
        if (!this.isLast(genericIndex, 'not-customizable')) {
          let wasUp = nodeData.output.generic[genericIndex]
          let wasDown = nodeData.output.generic[genericIndex + 1]
          nodeData.output.generic.splice(genericIndex, 1, wasDown)
          nodeData.output.generic.splice(genericIndex + 1, 1, wasUp)
        }
      } else {
        if (!this.isLast(genericIndex, outputResponseIndex)) {
          const response = nodeData.outputResponses[outputResponseIndex]
          let wasUp = response.output.generic[genericIndex]
          let wasDown = response.output.generic[genericIndex + 1]
          response.output.generic.splice(genericIndex, 1, wasDown)
          response.output.generic.splice(genericIndex + 1, 1, wasUp)
        }
      }
    },
    isLast (genericIndex, outputResponseIndex) {
      if (
        this.nodeData.data?.metadata?._customization?.mcr !== true &&
        outputResponseIndex === 'not-customizable'
      ) {
        if (this.nodeData.data.output.generic[genericIndex + 1]) {
          return false
        } else {
          return true
        }
      } else {
        if (
          this.nodeData.data.outputResponses[outputResponseIndex].output
            .generic[genericIndex + 1]
        ) {
          return false
        } else {
          return true
        }
      }
    },
    deleteResponse (genericIndex, outputResponsesIndex) {
      // console.log(`delete`)
      const nodeData = this.nodeData.data
      if (
        nodeData?.metadata?._customization?.mcr !== true &&
        outputResponsesIndex === 'not-customizable'
      ) {
        nodeData.output.generic.splice(genericIndex, genericIndex ? 1 : 0)
      } else {
        nodeData.outputResponses[outputResponsesIndex].output.generic.splice(
          genericIndex,
          genericIndex ? 1 : 0
        )
      }
    },
    addResponse (outputResponsesIndex) {
      const nodeData = this.nodeData.data
      if (
        nodeData.metadata?._customization?.mcr !== true &&
        outputResponsesIndex === 'not-customizable'
      ) {
        if (!nodeData.output) {
          nodeData.output = {}
          this.$forceUpdate()
        }
        if (!nodeData.output.generic) {
          nodeData.output.generic = []
          this.$forceUpdate()
        }
        nodeData.output.generic.push({
          values: [
            {
              text: ''
            }
          ],
          response_type: 'text',
          selection_policy: 'sequential'
        })
      } else {
        const isFirstCondition = nodeData.outputResponses.length === 0
        const response = {
          type: 'response_condition',
          dialog_node: `customResponse_${uuidv4()}`,
          output: {
            generic: [
              {
                values: [
                  {
                    text: ''
                  }
                ],
                response_type: 'text',
                selection_policy: 'sequential'
              }
            ]
          },
          next_step: {
            selector: 'body',
            behavior: 'skip_user_input',
            dialog_node: nodeData.dialog_node
          },
          context: {},
          conditions: '',
          parent: nodeData.dialog_node
        }
        if (!isFirstCondition) {
          const indexPreviousSibling = nodeData.outputResponses.length - 1
          response.previous_sibling = nodeData.outputResponses[indexPreviousSibling].dialog_node
        }
        nodeData.outputResponses.push(response)
        this.nodeMap[response.dialog_node] = response
      }
    },
    deleteVariations (genericIndex, valuesIndex, outputResponsesIndex) {
      const nodeData = this.nodeData.data
      if (
        nodeData?.metadata?._customization?.mcr !== true &&
        outputResponsesIndex === 'not-customizable'
      ) {
        nodeData.output.generic[genericIndex].values.splice(valuesIndex, 1)
        if (nodeData.output.generic[genericIndex].values.length === 0) {
          nodeData.output.generic[genericIndex].values.push({
            text: ''
          })
        }
      } else {
        const response = nodeData.outputResponses[outputResponsesIndex]
        response.output.generic[genericIndex].values.splice(valuesIndex, 1)
        if (response.output.generic[genericIndex].values.length === 0) {
          response.output.generic[genericIndex].values.push({
            text: ''
          })
        }
      }
    },
    addVariations (genericIndex, outputResponsesIndex) {
      const nodeData = this.nodeData.data
      if (
        nodeData?.metadata?._customization?.mcr !== true &&
        outputResponsesIndex === 'not-customizable'
      ) {
        nodeData.output.generic[genericIndex].values.push({
          text: ''
        })
      } else {
        const response = nodeData.outputResponses[outputResponsesIndex]
        response.output.generic[genericIndex].values.push({
          text: ''
        })
      }
    },
    changeVariationType (genericIndex, newType, outputResponseIndex) {
      const nodeData = this.nodeData.data
      if (
        nodeData?.metadata?._customization?.mcr !== true &&
        outputResponseIndex === 'not-customizable'
      ) {
        if (newType === 'sequencial') {
          nodeData.output.generic[genericIndex].selection_policy = 'sequential'
        } else if (newType === 'aleatória') {
          nodeData.output.generic[genericIndex].selection_policy = 'random'
        } else if (newType === 'multilinha') {
          nodeData.output.generic[genericIndex].selection_policy = 'multiline'
        }
      } else {
        const response = nodeData.outputResponses[outputResponseIndex]
        if (newType === 'sequencial') {
          response.output.generic[genericIndex].selection_policy = 'sequential'
        } else if (newType === 'aleatória') {
          response.output.generic[genericIndex].selection_policy = 'random'
        } else if (newType === 'multilinha') {
          response.output.generic[genericIndex].selection_policy = 'multiline'
        }
      }
    },
    variationType (type) {
      if (type === 'sequential') {
        return {
          selected: 'sequencial',
          variations: ['aleatória', 'multilinha']
        }
      } else if (type === 'random') {
        return {
          selected: 'aleatória',
          variations: ['sequencial', 'multilinha']
        }
      } else if (type === 'multiline') {
        return {
          selected: 'multilinha',
          variations: ['sequencial', 'aleatória']
        }
      }
    }
  }
}
